import * as axios from '../../utilities/axios'

export const unsubscribeByFetcherSearchContactInfo = objectId => {
  return axios.basic
    .post(`/api/v1/fetcher/unsubscribe/${objectId}`)
    .then(res => res.data)
    .catch(axios.parseError)
}
